import React from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'

import { descriptions, tooltipText } from '../../utils/userstats'

const UserStat = props => (
  <div className="user-stat">
    <ReactTooltip
      id={`${props.type}-tooltip`}
      effect="solid"
      offset={{ bottom: 35 }}
    />
    <div className={`icon ${props.type}`} />
    <div
      className="stat-value"
      data-for={`${props.type}-tooltip`}
      data-tip={tooltipText[props.type]}
    >
      {props.hasNoCompletedQuests ? 'N/A' : props.value}
    </div>
    <div className="stat-description-container">
      <div className="stat-description">{descriptions[props.type]}</div>
    </div>
  </div>
)

UserStat.propTypes = {
  type: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  hasNoCompletedQuests: PropTypes.bool
}

export default UserStat



// WEBPACK FOOTER //
// ./src/components/myquests/UserStat.js